import { render } from "./Workspace.vue?vue&type=template&id=0a39c5ca"
import script from "./Workspace.vue?vue&type=script&lang=js"
export * from "./Workspace.vue?vue&type=script&lang=js"

import "./Workspace.vue?vue&type=style&index=0&id=0a39c5ca&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__